// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__3XA3L","loaderOuter":"PageOverlayLoader_loaderOuter__g6XJe"};